// extracted by mini-css-extract-plugin
export var subtitle = "_8z-2";
export var title = "_8z-0";
export var titleNoWrap = "_8z-1";